import "../css/Contact.css";

const Contact = () => {
  return (
    <main className="salon-contact">

      {/* HERO */}
      <section className="contact-hero">
        <h1>Contact</h1>
        <p>
          Visit us.<br />
          We’d love to welcome you.
        </p>
      </section>

      {/* MAP */}
      <section className="contact-map">
        <iframe
          title="Salon Location"
          src="https://www.google.com/maps?q=salon&output=embed"
          loading="lazy"
        />
      </section>

      {/* INFO */}
      <section className="contact-info">
        <div>
          <span>Location</span>
          <p>
            28 Rue Blanche<br />
            Downtown District
          </p>
        </div>

        <div>
          <span>Hours</span>
          <p>
            Tuesday – Sunday<br />
            10:00 AM – 7:00 PM
          </p>
        </div>

        <div>
          <span>Contact</span>
          <p>
            hello@elansalon.com<br />
            +1 (555) 483-2091
          </p>
        </div>
      </section>

      {/* CLOSING */}
      <section className="contact-closing">
        <p>
          Beauty begins<br />
          with a conversation.
        </p>
      </section>

    </main>
  );
};

export default Contact;
